import qs from 'qs';
import { setSubmitting } from 'src/redux/modules/webpage/loading';

import { API_METHOD, authApiClient } from '../../api';

// 액션 타입
const LOAD_REVIEW_GROUPS = 'reviewGroups/LOAD_REVIEW_GROUPS';

// 액션 생성함수
const loadReviewGroups = reviewGroups => ({ type: LOAD_REVIEW_GROUPS, reviewGroups });

export const handleLoadReviewGroups = query => {
  return async dispatch => {
    try {
      dispatch(setSubmitting(true));
      const response = await authApiClient(
        API_METHOD.GET,
        `${Object.keys(query).length ? `review/group?limit=10&${qs.stringify(query)}` : 'review/group?limit=10'}`
      );
      dispatch(loadReviewGroups(response.data.result));
    } catch (e) {
      alert(e.message);
    } finally {
      dispatch(setSubmitting(false));
    }
  };
};

// 초기 상태 선언 (컴포넌트가 state.reviewGroups.rows/.count로 접근하므로 로드 전에도 안전한 형태)
const initialState = { rows: [], count: 0 };

// 리듀서 선언
export default function reviewGroups(state = initialState, action) {
  switch (action.type) {
    case LOAD_REVIEW_GROUPS: {
      return action.reviewGroups;
    }
    default:
      return state;
  }
}
